import './Extra.css';

function LetterToMin() {
  return (
    <div className="LetterToMin">
      <p>
        P.S. For Min! The most amazing Literary Arts leader ever! <a 
        href="https://docs.google.com/document/d/1ZCNSWZck-mkBN4zC1jv1iSqG4HA_qzvkzWLfQkwyxJo/edit?usp=sharing"> A letter for you!</a>
      </p>
      <p>
        P.P.S For anyone interested in something silly and not at all like this! <a 
        href="http://www.theribofbrown.com/classics-concentrator-teaches-tinder-date-about-oedipus/">A fun little piece :)</a>
      </p>
    </div>
  );
}

export default LetterToMin;
